import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import rpm from "../images/carepro.jpg";
// Encryption and Decryption Functions
import { encryptBody } from "encryptionAndDecryption/bodyEncryption";
import { decryptBody } from "encryptionAndDecryption/bodyDecryption";
import { fetchSecretKey } from "encryptionAndDecryption/secretKeyDecryption";// your encryption functions

function Privacypolicy() {
  const [accepted, setAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

 const handleAccept = async () => {
  if (!accepted) {
    toast.error("Please accept the privacy policy to continue.");
    return;
  }

  setLoading(true);

  try {
    const loginData = JSON.parse(localStorage.getItem("loginData"));
    if (!loginData || !loginData.userid) {
      toast.error("Session expired. Please login again.");
      navigate("/login");
      return;
    }

    const secretKey = await fetchSecretKey();
    const encryptedPayload = encryptBody({ userid: loginData.userid }, secretKey);

    const response = await axios.post("/api/accept-privacy", encryptedPayload, {
      headers: {
        "Content-Type": "text/plain",
      },
    });

    const decryptedResponse = decryptBody(response.data, secretKey);

    if (!decryptedResponse?.success) {
      toast.error(decryptedResponse?.message || "Unable to save privacy acceptance.");
      return;
    }

    loginData.privacyAccepted = true;
    localStorage.setItem("loginData", JSON.stringify(loginData));

    toast.success("Privacy Policy Accepted. Please login.");
    navigate("/login"); // Force login after accepting
  } catch (err) {
    console.error(err);
    toast.error("An error occurred while accepting privacy policy.");
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="col-xl-12 mx-xl-auto" style={{ padding: "20px", backgroundColor: "white" }}>
      <div className="card card-raised mb-3">
        <div className="card-body p-4">
          {/* Header */}
          <div
            style={{
              backgroundColor: "#2e7faeff",
              color: "white",
              padding: "15px",
              textAlign: "center",
              position: "relative",
              border: "2px solid white",
              marginBottom: "20px",
            }}
          >
            <img
              src={rpm}
              alt="Logo"
              style={{
                height: "50px",
                position: "absolute",
                left: "20px",
                top: "50%",
                transform: "translateY(-50%)",
              }}
            />
            <h2 style={{ margin: 0 }}>Privacy Policy</h2>
          </div>

          {/* Privacy Content */}
          <div style={{ maxHeight: "300px", overflowY: "scroll" }}>
            <div className="card-body p-4">
            {/* Blue Header Box with Border & Margin */}
           
                
            <h4>1. INTRODUCTION</h4>
            
              
              StellarRCM Private Limited ("Company", "we", "us", "our") respects
              the privacy of our users ("user", "you", "your"). This Privacy
              Policy explains how we collect, use, disclose, and safeguard your
              information when you visit our website or use our services.
           
            <h4> 2. DATA COLLECTION </h4>
            
              We may collect and process the following data about you:
              <ul style={{ marginLeft: "40px" }}>
                {" "}
                <li>
                  <h5>Identity and Contact Data:</h5> This includes data which
                  relates to your identity such as your first name, last name,
                  username, title, billing address, delivery address, email
                  address, and telephone numbers.
                </li>{" "}
                <li>
                  <h5>Technical Data:</h5> This may include information such as
                  geolocation data, IP address, your login data, the type of
                  device you used to access our site or services, your internet
                  service provider, your device’s operating system, browser
                  type, the pages you viewed and the order of those pages, and
                  the date and time of your visit.
                </li>{" "}
                <li>
                  {" "}
                  <h5> Usage Data:</h5> This includes details of your usage of
                  our website, products, and services, including traffic data,
                  logs and other communication data and resources, as well as
                  information about how you respond to our marketing
                  communications.
                </li>{" "}
                <li>
                  {" "}
                  <h5>Marketing and Communications Data:</h5> This includes your
                  preferences in receiving marketing from us and our third
                  parties and your communication preferences.
                </li>
              </ul>
            
            <h4> 3. USE OF YOUR INFORMATION</h4>
           
              We use the collected data for various purposes:
              <ul style={{ marginLeft: "40px" }}>
                <li>To maintain and improve our website and services</li>
                <li>
                  To manage your account and provide you with customer support
                </li>{" "}
                <li>
                  To perform research and analysis about your use of our
                  services
                </li>
                <li>
                  {" "}
                  To develop and display content and advertising tailored to
                  your interests on our website and other sites
                </li>{" "}
                <li>
                  {" "}
                  To verify your eligibility and deliver prizes in connection
                  with contests and sweepstakes{" "}
                </li>{" "}
                <li>
                  {" "}
                  To enforce our terms and conditions To manage our business and
                  perform functions as otherwise described to you at the time of
                  collection.
                </li>
              </ul>
            
            <h4> 4. DATA DISCLOSURE</h4>
            
              
              We do not share your personal information with others except as
              indicated within this policy or when we inform you and give you an
              opportunity to opt-out of having your personal information shared.
            
            <h4> 5. DATA SECURITY</h4>
            
              We have implemented measures designed to secure your personal
              information from accidental loss and from unauthorized access,
              use, alteration, and disclosure.
          
            <h4> 6. DATA RETENTION</h4>
            
              We retain personal information for as long as necessary to fulfill
              the purposes for which you provided it, comply with our legal
              obligations, resolve disputes, and enforce our legal agreements
              and policies.
            
            <h4> 7. YOUR RIGHTS </h4>
            
              Under the data protection laws, you have a number of important
              rights. Those include rights to:
              <ul style={{ marginLeft: "40px" }}>
                {" "}
                <li>
                  {" "}
                  Fair processing of information and transparency over how we
                  use your use personal information
                </li>
                <li> Access to your personal information</li>{" "}
                <li>
                  {" "}
                  Require us to correct any mistakes in your information which
                  we hold
                </li>{" "}
                <li>
                  {" "}
                  Require the deletion of personal information concerning you in
                  certain situations
                </li>{" "}
                <li>
                  {" "}
                  Receive the personal information concerning you which you have
                  provided to us, in a structured, commonly used, and
                  machine-readable format
                </li>{" "}
                <li>
                  {" "}
                  Object at any time to processing of personal information
                  concerning you for direct marketing
                </li>{" "}
                <li>
                  {" "}
                  Object to decisions being taken by automated means which
                  produce legal effects concerning you or s imilarly
                  significantly affect you
                </li>{" "}
                <li>
                  {" "}
                  Object in certain other situations to our continued processing
                  of your personal information
                </li>
              </ul>
            
            <h4>8.CHANGES TO THE POLICY</h4>
           
              We will post any changes we make to our privacy policy on this
              page and, if they’re significant changes, we will notify you by
              sending you an email.
            
            <h4>9. CONTACT US</h4>
            
              Should you have any queries regarding this Privacy Policy, about
              our processing of your personal data or wish to exercise your
              rights you can contact StellarRCM's Data Protection Officer using
              this email address: support@stellarrcm.com. This is without
              prejudice to your right to launch a claim with your data
              protection authority
            
          </div>
          </div>

          {/* Accept Section */}
          <div style={{ marginTop: "30px" }}>
            <label style={{ display: "flex", alignItems: "center" }}>
              <input
                type="checkbox"
                checked={accepted}
                onChange={(e) => setAccepted(e.target.checked)}
                style={{ marginRight: "10px" }}
              />
              <h5 style={{ margin: 0 }}>I agree to the Privacy Policy</h5>
            </label>

            <button
              onClick={handleAccept}
              disabled={loading}
              style={{
                marginTop: "20px",
                padding: "12px 25px",
                backgroundColor: "#2e7fae",
                color: "white",
                border: "none",
                borderRadius: "6px",
                cursor: loading ? "not-allowed" : "pointer",
              }}
            >
              {loading ? "Processing..." : "Continue"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Privacypolicy;
